import {fetchQuestionTypeUrl, insertQuestionDetailsUrl,fetchEmojiUrl,fetchQuestionChoiceUrl, getFeedbackTypesUrl,
  getApplicationQuestionListUrl,UpdateMissionQuestionDetailsUrl,DeleteMissionQuestionDetailsUrl,
  getRejectFeedbackQuestionListUrl} from '../../Comman/apiEndPoints';
import varAxios from "../../Comman/axios";
import formDataAxios from "../../Comman/formDataAxios";

export const FETCH_QUESTION_TYPE_REQUEST = "(fetch) FETCH QUESTION TYPE REQUEST";
export const FETCH_QUESTION_TYPE_SUCCESS = "(fetch) FETCH QUESTION TYPE SUCCESS";
export const FETCH_QUESTION_TYPE_ERROR = "(fetch) FETCH QUESTION TYPE ERROR";

export const FETCH_EMOJI_REQUEST = "(fetch) FETCH EMOJI REQUEST";
export const FETCH_EMOJI_SUCCESS = "(fetch) FETCH EMOJI SUCCESS";
export const FETCH_EMOJI_ERROR = "(fetch) FETCH EMOJI ERROR";

export const INSERT_QUESTIONS_DETAILS_REQUEST = "(insert) INSERT QUESTIONS DETAILS REQUEST";
export const INSERT_QUESTIONS_DETAILS_SUCCESS = "(insert) INSERT QUESTIONS DETAILS SUCCESS";
export const INSERT_QUESTIONS_DETAILS_ERROR = "(insert) INSERT QUESTIONS DETAILS RROR";

export const FETCH_FEEDBACK_QUES_ANS_LIST_REQUEST = "(fetch) FETCH FEEDBACK QUES ANS LIST REQUEST";
export const FETCH_FEEDBACK_QUES_ANS_LIST_SUCCESS = "(fetch) FETCH FEEDBACK QUES ANS LIST SUCCESS";

export const UPDATE_QUESTION_DETAILS_SETTINGS_REQUEST = "(update) UPDATE QUESTION DETAILS SETTINGS REQUEST";
export const UPDATE_QUESTION_DETAILS_SETTINGS_SUCCESS = "(update) UPDATE QUESTION DETAILS SETTINGS SUCCESS"; 

export const DELETE_QUESTION_DETAILS_REQUEST = "(delete) DELETE QUESTION DETAILS REQUEST";
export const DELETE_QUESTION_DETAILS_SUCCESS = "(delete) DELETE QUESTION DETAILS SUCCESS"; 

export const FETCH_FEEDBACK_TYPES_REQUEST = "FETCH_FEEDBACK_TYPES_REQUEST";
export const FETCH_FEEDBACK_TYPES_SUCCESS = "FETCH_FEEDBACK_TYPES_SUCCESS";
export const REJECT_ANSWER_LIST_REQUEST = "REJECT_ANSWER_LIST_REQUEST";
export const REJECT_ANSWER_LIST_SUCCESS = "REJECT_ANSWER_LIST_SUCCESS";

export function fetchQuestionType(dispatch) { 
  return (dispatch) => {
      dispatch(fetchQuestionTypeRequest(true));

      return varAxios.get(fetchQuestionTypeUrl)
          .then((response) => { 
              dispatch(
                  fetchQuestionTypeSuccess(false, response.data.QuestionTypes)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchQuestionTypeRequest(isLoading) {
  return {
      type: FETCH_QUESTION_TYPE_REQUEST,
      isLoading
  }
}

export function fetchQuestionTypeSuccess(isLoading, questionType) {   
  return {
      type: FETCH_QUESTION_TYPE_SUCCESS,
      isLoading,
      questionType
  }
}


export function fetchEmoji(dispatch) { 
  return (dispatch) => {
      dispatch(fetchEmojiRequest(true));

      return varAxios.get(fetchEmojiUrl)
          .then((response) => { 
              dispatch(
                  fetchEmojiSuccess(false, response.data.EmojiImages)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchEmojiRequest(isLoading) {
  return {
      type: FETCH_EMOJI_REQUEST,
      isLoading
  }
}

export function fetchEmojiSuccess(isLoading, emojiImage) {   
  return {
      type: FETCH_EMOJI_SUCCESS,
      isLoading,
      emojiImage
  }
}

export function fetchFeedbackTypes(dispatch) { 
  return (dispatch) => {
      dispatch(fetchFeedbackTypesRequest(true));

      return varAxios.get(getFeedbackTypesUrl)
          .then((response) => { 
              dispatch(
                  fetchFeedbackTypesSuccess(false, response.data.applicationFeedbackTypes)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchFeedbackTypesRequest(isLoading) {
  return {
      type: FETCH_FEEDBACK_TYPES_REQUEST,
      isLoading
  }
}

export function fetchFeedbackTypesSuccess(isLoading, FeedbackTypesList) {   
  return {
      type: FETCH_FEEDBACK_TYPES_SUCCESS,
      isLoading,
      FeedbackTypesList
  }
}

export function insertQuestionDetailsSettings(isLoading, questionDetailsSettingsList, dispatch) {
  return (dispatch) => {
      dispatch(insertQuestionSettingsDetailRequest(true)); 
      return varAxios.post(insertQuestionDetailsUrl, questionDetailsSettingsList,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {

              dispatch(
                insertQuestionSettingsDetailSuccess(false,
                   response.data.List, 
                   response.data.Message,
                   response.data.statusCode
                   
                   )
              );
          })
          .catch((error) => {
          })
  }
}


export function insertQuestionSettingsDetailRequest(isLoading) {
  return {
      type: INSERT_QUESTIONS_DETAILS_REQUEST,
      isLoading 
  }
}

export function insertQuestionSettingsDetailSuccess(isLoading, questionList, messageLabel,statusCode) {
  return {
      type: INSERT_QUESTIONS_DETAILS_SUCCESS,
      isLoading,
      questionList,
      messageLabel,
      statusCode
  }
}
 
export function fetchFeedbackQuesAnsList(dispatch) { 
  return (dispatch) => {
      dispatch(fetchFeedbackQuesAnsListRequest(true));

      return varAxios.get(fetchQuestionChoiceUrl)
          .then((response) => { 
              dispatch(
                fetchFeedbackQuesAnsListSuccess(false, response.data.list)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchAppFeedbackQuesAnsList(dispatch) { 
  return (dispatch) => {
      dispatch(fetchFeedbackQuesAnsListRequest(true));

      return varAxios.get(getApplicationQuestionListUrl)
          .then((response) => { 
              dispatch(
                fetchFeedbackQuesAnsListSuccess(false, response.data.list)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchFeedbackQuesAnsListRequest(isLoading) {
  return {
      type: FETCH_FEEDBACK_QUES_ANS_LIST_REQUEST,
      isLoading
  }
}

export function fetchFeedbackQuesAnsListSuccess(isLoading, questionList) {   
  return {
      type: FETCH_FEEDBACK_QUES_ANS_LIST_SUCCESS,
      isLoading,
      questionList
  }
}



export function updateQuestionDetailsSettings(isLoading, questionList, dispatch) {

  return (dispatch) => {
      dispatch(updateQuestionDetailsSettingsRequest(true));

      return varAxios.post(UpdateMissionQuestionDetailsUrl, questionList,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              console.log(response)
              dispatch(
                updateQuestionDetailsSettingsSuccess(false,
                   response.data.List, 
                   response.data.Message,
                   response.data.statusCode
                   )
              );
          })
          .catch((error) => {
          })
  }
}


export function updateQuestionDetailsSettingsRequest(isLoading,statusCode) {
  return {
      type: UPDATE_QUESTION_DETAILS_SETTINGS_REQUEST,
      isLoading,
      statusCode
  }
}

export function updateQuestionDetailsSettingsSuccess(isLoading, questionList, messageLabel,statusCode) {
  return {
      type: UPDATE_QUESTION_DETAILS_SETTINGS_SUCCESS,
      isLoading,
      questionList,
      messageLabel,
      statusCode
  }
}


export function deleteQuestionDetails(isLoading, questionID, dispatch) { 
  return (dispatch) => {
      dispatch(deleteQuestionDetailsRequest(true));

      return varAxios.delete(DeleteMissionQuestionDetailsUrl, { data: questionID },
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              
              dispatch(
                deleteQuestionDetailsSuccess(false, 
                      response.data.List, 
                      response.data.Message,
                      response.data.statusCode

                      )
              );
          })
          .catch((error) => {
          })
  }
}


export function deleteQuestionDetailsRequest(isLoading,statusCode) {
  return {
      type: DELETE_QUESTION_DETAILS_REQUEST,
      isLoading,
      statusCode
  }
}

export function deleteQuestionDetailsSuccess(isLoading, questionList, errorMessage,statusCode) {
  return {
      type: DELETE_QUESTION_DETAILS_SUCCESS,
      isLoading,
      questionList,
      errorMessage,
      statusCode
  }
}
export function rejectFeedbackQuesList(dispatch) { 
  return (dispatch) => {
      dispatch(fetchFeedbackQuesAnsListRequest(true));
      return varAxios.get(getRejectFeedbackQuestionListUrl)
          .then((response) => { 
              dispatch(
                fetchFeedbackQuesAnsListSuccess(false, response.data.list)
              );
          })
          .catch((error) => {
          })
  }
}


